import { useEffect, useRef, useState } from "react";
import './page-detail.scss';
import ImageElement from "../../../elements/ImageElement";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { useLocation, useParams } from "react-router-dom";
import { ProjectModel } from "../../../models/Project";
import "@lottiefiles/lottie-player";
import { isSafari } from 'react-device-detect';
import api from "../../../api";
import { SentenceScramble } from "../../../ultils/SentenceScramble";
import VideoElement from "../../../elements/VideoElement";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import LottieElement from "../../../elements/LottieElement";

const ProjectDetailDesktop = () => {
  const { id } = useParams();
  const ref = useRef<any>();
  const height = useSelector((state: RootState) => state.sizeContent.height);
  const widthContent = useSelector((state: RootState) => state.sizeContent.width);
  const projectList = useSelector((state: RootState) => state.projectList);
  const location = useLocation();
  const [prevPathName, setPrevPathName] = useState('')
  const [loadedCount, setLoadedCount] = useState(0);
  const [project, setProject] = useState<ProjectModel>({} as ProjectModel);
  const allVideosLoaded = project && project.detailImages && loadedCount === project.detailImages.length;
  const className = isSafari ? 'project-client-title-safari' : 'project-client-title';

  useEffect(() => {
    if (location && location.state) {
      if (prevPathName !== location.pathname) {
        // Cache prev path name...
        // console.warn(`prevLocation: ${prevPathName}, location.pathname: ${location.pathname}, Project changed, resetting load count...`)
        setPrevPathName(location.pathname)
        setLoadedCount(0);
        setProject(location.state);
      }     
    }
    else if(projectList) {
      let charExits = /\W/g;
      const state = projectList.find(item => item.title.replaceAll(" ", "_").replace(charExits, '') === id)
      location.state = state;
    }
    else {
      _getAllProject().then();
      location.state = project;
    }
    const topElement = document.getElementById('header-project-detail');
    if (topElement) {
      topElement.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.state, id]);

  const _getAllProject = async () => {
    try {
      const res = await api.project.getAllProject();
      let charExits = /\W/g;
      const state = res.data.find((item : ProjectModel) => item.title.replaceAll(" ", "_").replace(charExits, '') === id)
      setProject(state);
    } catch (err) {
      // If cannot retrieve from database, fallback to local saves
      console.error("Cannot retrieve data from database...");
    }
  };

  useEffect(() => {
    // console.log('attempt sentence scramble')
    const sentenceScrambler = new SentenceScramble(`project-sentence-scrambler`, () => {}, false);
    const capsSentenceScrambler = new SentenceScramble(`project-sentence-scrambler-caps`, () => {}, true);
    sentenceScrambler.startScramble(0.5, 0);
    capsSentenceScrambler.startScramble(0.5, 0);
  }, [project]);

  useEffect(() => {
    if (project?.detailImages && loadedCount === project.detailImages.length) {
      // console.log(`projects loaded: ${loadedCount}, totalCount: ${project.detailImages.length}. REFRESHING SCROLL TRIGGER!`)
      // All images/videos/lotties loaded, trigger refresh
      ScrollTrigger.refresh();
    }
    // else
    // {
    //   console.log(`loadedCount: ${loadedCount}`)
    // }
  }, [loadedCount, project]);

  const registerLoad = () => {
    setLoadedCount(prevCount => prevCount + 1);
  };


  const _renderProjectName = () => {
    return (
      <div className={'text-title-container-detail'}>
        <p className={className}>{'< CLIENT >'}</p>
        <p className={'text-project-title project-sentence-scrambler-caps'}>{project.title}</p>
        <p
          className='text-title-detail project-sentence-scrambler-caps'
          style={{
            fontSize: height / 13
          }}
        >
          {project.detailTitle}
        </p>
      </div>
    )
  };

  const _renderProjectInfo = () => {
    return (
      <div className={'project-detail-info-container2'}>
        <div className={'info-left'}>
          <p className={className}>{`< THE EXPERIMENT >`}</p>
          <p className={'detail_description-project project-sentence-scrambler'}>{project.detailDescription}</p>
        </div>
        <div className={'info-right'}>
          <p className={className}>{`< SERVICES >`}</p>
          <div className={'description-detail'}>
            <div className={'left'}>
              {project && project.services && project.services.map((item, index) => {
                if (index % 2 === 0) return (<div className={'project-client project-sentence-scrambler-caps'} key={item}> {item} <br /></div>)
              })}
            </div>
            <div className={'right'}>
              {project && project.services && project.services.map((item, index) => {
                if (index % 2 !== 0) return (<div className={'project-client project-sentence-scrambler-caps'} key={item}> {item} <br /></div>)
              })}
            </div>
          </div>
        </div>
      </div>
    )
  };

  const _renderImage = (link: string, index: number) => {
    return (
      <div className={'image-container'} key={index}>
        <ImageElement
          src={link}
          alt={''}
          className="images-project"
          scroller=".project-detail-container"
          onReady={registerLoad}
          canAnimate={allVideosLoaded}
        />
      </div>
    )
  };

  const _renderVideo = (link: string, index: number) => {
    return (
      <div className={'image-container'} key={index}>
        <VideoElement
          key={index}
          src={link}
          className="video-project"
          scroller=".project-detail-container"
          onReady={registerLoad}
          canAnimate={allVideosLoaded}
        />
      </div>    
    );
  };

  const _renderLottie = (link: string, index: number) => {
    return (
      <div className='image-container' key={index}>
        <LottieElement
          src={link}
          className='project-image'
          scroller=".project-detail-container"
          onReady={registerLoad}
        />
      </div>
    );
  };

  return (
    <div ref={ref}
      className={'project-detail-container'}
      style={{ height: height * 0.8 }}
      id={'header-project-detail'}
      key={project.id}
    >
      <div className='project-detail-container-border' style={{ height: height * 0.8, width: height * 0.8 * 4 / 3}}></div>
      <div
        className='project-detail-info-container'
        style={{
          fontSize: widthContent / 180,
        }}
      >
        {_renderProjectName()}
        {_renderProjectInfo()}
      </div>
      {project && project.detailImages && project.detailImages.map((item, index) => {
        if (item.includes('.json')) {
            return _renderLottie(item, index)
          } else if (item.includes('.mp4')) {
            return _renderVideo(item, index)
          } else {
            return _renderImage(item, index)
          }
      })}
    </div>
  )
};

export default ProjectDetailDesktop;
